import { environment } from '@environments/environment';
import { RegionAvailable } from '@shared/services/language/registry';

export const envConfiguredSearchableCountries = (region: RegionAvailable) =>
  environment.domains[region].searchableCountries ?? [];
